import React from 'react'

const Transitation = () => {
  return (
    <div>TransAction</div>
  )
}

export default Transitation